import { BaseSignatureInserter } from "@/features/background/launchevent/BaseSignatureInserter";
import { OutlookNewSignatureInserter } from "@/features/background/launchevent/OutlookNewSignatureInserter";
import { OutlookClassicSignatureInserter } from "@/features/background/launchevent/OutlookClassicSignatureInserter";
import { OutlookMobileSignatureInserter } from "@/features/background/launchevent/OutlookMobileSignatureInserter";
import { info, debug } from "@/shared/services/logger";

const SOURCE = "platform";

/**
 * Verifica se a plataforma atual é mobile (Android ou iOS).
 *
 * @returns `true` se estiver rodando no Outlook Mobile.
 *
 * @example
 * ```typescript
 * if (isMobilePlatform()) {
 *   console.log("Executando no Outlook Mobile.");
 * }
 * ```
 */
export function isMobilePlatform(): boolean {
  const platform = Office?.context?.platform as unknown as string;
  return platform === "Android" || platform === "iOS";
}

/**
 * Detecta a plataforma do Outlook e instancia o inserter adequado.
 *
 * @param caller - Identificador do módulo chamador para os logs.
 * @returns Instância de `BaseSignatureInserter` para a plataforma atual.
 *
 * @example
 * ```typescript
 * const inserter = createInserter("taskpane");
 * ```
 */
export function createInserter(caller: string): BaseSignatureInserter {
  const platform = Office.context?.platform as unknown as string;
  const host = Office.context?.diagnostics?.host as unknown as string;
  debug(SOURCE, `[${caller}] Plataforma detectada: ${platform}, host: ${host}`);

  if (platform === "PC" && host === "Outlook") {
    info(SOURCE, `[${caller}] Outlook Classic → OutlookClassicSignatureInserter.`);
    return new OutlookClassicSignatureInserter();
  }

  if (isMobilePlatform()) {
    info(SOURCE, `[${caller}] Outlook Mobile → OutlookMobileSignatureInserter.`);
    return new OutlookMobileSignatureInserter();
  }

  info(SOURCE, `[${caller}] Outlook New/Web → OutlookNewSignatureInserter.`);
  return new OutlookNewSignatureInserter();
}
